(function () {
  'use strict';

  class DeviceHealthCtrl {
    constructor($document, $safetyService, $window, $scope, $log, Authenticator, FeatureOuService, FeaturehubJsSdk, FeatureHubConfigKeys,
      $state, Keys, ServiceVfiltro, FactoryVfiltro, $translate) {
      this.log = $log;
      this.scope = $scope;
      this.window = $window;
      this.document = $document[0];
      this.safetyService = $safetyService;
      this.safetyApp = 'safetyApp';
      this.deviceHealth = './DeviceHealthPageRoute';
      this.safetyElement = 'safety-app-device-health';
      this.container = this.document.getElementById(this.safetyElement);
      this.translate = $translate;
      this.authenticator = Authenticator;
      this.user = {};
      this.featureOuService = FeatureOuService;
      this.featurehubJsSdk = FeaturehubJsSdk;
      this.featureHubConfigKeys = FeatureHubConfigKeys;
      this.state = $state;
      this.isFeatureFlagDeviceHealthPageEnabled = this.featurehubJsSdk.isFeatureEnabled(this.featureHubConfigKeys.DEVICE_HEALTH_PAGE);
      this.isFeatureTelematicsTableEnabled = this.featurehubJsSdk.isFeatureEnabled(this.featureHubConfigKeys.DEVICE_HEALTH_TELEMATICS_TABLE);
      this.keys = Keys;
      this.serviceVfiltro = ServiceVfiltro;

      this.authenticator.getUser()
        .then(user => {
          this.user = user;

          ServiceVfiltro.init(FactoryVfiltro.get(this.handleGetVFiltro()))
          .then((filtro) => {
            this.filtro = filtro;
            this.initializePage(this.serviceVfiltro.getFiltroBackendNovo(this.filtro));
          });
          this.scope.$on('$destroy', () => {
            this.unmountReactComponent();
          });
        });
    }

    handleGetVFiltro() {
      if (!this.user.isNa && this.isFeatureTelematicsTableEnabled) {
        return [
          {
            name: 'uoId',
            required: true,
            key: this.keys.uo.name,
            size: 12
          },
          {
            name: 'mainSemaphoreStatus',
            required: false,
            key: this.keys.vehicleHealthStatus.name,
            size: 6
          }
        ];
      }
      return [
        {
          name: 'uoId',
          required: true,
          key: this.keys.uo.name,
          size: 12
        },
        {
          name: 'vehiclesWithDevices',
          required: false,
          key: this.keys.vehiclesWithDevices.name,
          size: 6,
          order: 5
        },
        {
          name: 'deviceHealthStatus',
          required: false,
          key: this.keys.deviceHealthStatus.name,
          size: 6
        },
        {
          name: 'sdCardStatus',
          required: false,
          key: this.keys.sdCardStatus.name,
          size: 6
        },
        {
          name: 'cameraDiagnostics',
          required: false,
          key: this.keys.cameraDiagnostics.name,
          size: 6
        }
      ];
    }

    initializePage(filter) {
      this.safetyService.initialize()
      .then(() => this.loadPage(filter))
        .catch(error => this.log.error('Initialization failed:', error));
    }

    loadPage(filter) {
      this.safetyService.getComponent(this.safetyApp, this.deviceHealth)
        .then(page => {
          if (this.isFeatureFlagDeviceHealthPageEnabled) {
            this.window.ReactDOM.render(
              this.window.React.createElement(page().default, {user: this.user, filter: filter}),
              this.container
            );
          }
        })
        .catch(error => {
          this.log.error('Error occurred:', error);
        });
    }

    unmountReactComponent() {
      if (this.window.ReactDOM && this.container) {
        if (this.window.ReactDOM.unmountComponentAtNode(this.container)) {
          this.log.log('React component unmounted');
        } else {
          this.log.log('React component was not mounted.');
        }
      } else {
        this.log.log('Container not found or React component was not mounted.');
      }
    }
  }
  DeviceHealthCtrl.$inject = ['$document', 'safetyService', '$window', '$scope', '$log', 'Authenticator', 'FeatureOuService', 'FeaturehubJsSdk', 'FeatureHubConfigKeys', '$state', 'Keys', 'ServiceVfiltro', 'FactoryVfiltro', '$translate'];
  angular.module('relatorios.deviceHealth').controller('DeviceHealthCtrl', DeviceHealthCtrl);
}());
